import { Component } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

import {EventsService} from '../../../../services/events/events.service';

@Component({
  selector: 'modal-logout',
  styleUrls: [('./modalLogout.scss')],
  templateUrl: './modalLogout.html'
})

export class ModalLogout {

  constructor(
    private _activeModal: NgbActiveModal, 
    private _eventsService: EventsService
  ) {

  }

  ngOnInit() {}

  public closeModal() {
    this._activeModal.close();
  }

  public logoutModal(){
    this._activeModal.close();
    this._eventsService.logoutEvent(true);
  }

}



// WEBPACK FOOTER //
// /app/src/app/theme/components/modals/components/modalLogout/modalLogout.component.ts